import { currentSuggestion } from '../state'

/**
 * Öneri verilerini formatlayarak görüntüleme için hazırlar
 * (Tarihler, HTML formatlamaları, özel alanlar vb.)
 * @returns {Object|null} Formatlanmış öneri verisi veya null
 */
export const formatSuggestion = () => {
  if (!currentSuggestion.value) return null

  const suggestion = { ...currentSuggestion.value }

  // Oluşturma ve güncelleme tarihlerini formatlama
  if (suggestion.createdAt) {
    suggestion.formattedCreatedAt = new Date(suggestion.createdAt).toLocaleString('tr-TR')
  }

  if (suggestion.updatedAt) {
    suggestion.formattedUpdatedAt = new Date(suggestion.updatedAt).toLocaleString('tr-TR')
  }

  // HTML içeriği varsa güvenli formatlama işlemleri yapılabilir
  // Bu örnekte basit olarak aynı şekilde bırakıyoruz

  return suggestion
}
